/**
 * Module IDs returned by /api/obd/user/profile/:userId.
 * The end-user sidebar uses these to gate accordion sections.
 * Names are derived from the legacy SideNav switch in obd_frontend.
 */
export const MODULE_IDS = {
  IVR: 1,
  RETRY: 2,
  WEBHOOK: 3,
  API: 4,
  DEDICATED_CLI: 5,
  INBOUND: 6,
  TTS: 7,
  MASKING: 8,
  SMS_WEBHOOK: 9,
  CONTINUOUS_CAMPAIGN: 10,
  REPORT_A: 11,
  REPORT_B: 12,
} as const;

export type ModuleId = (typeof MODULE_IDS)[keyof typeof MODULE_IDS];

/**
 * Filter-set keys cached in the sub-super-admin moduleListing localStorage,
 * mirroring legacy MODULE_LISTING_CONSTANT.
 */
export const MODULE_LISTING_KEYS = {
  MANAGE_API_CLI: 'Manage API CLI',
  MANAGE_CLI: 'Manage CLI',
  MANAGE_DIALERS: 'Manage Dialers',
  MANAGE_GROUPS: 'Manage Groups',
  MANAGE_LOCATIONS: 'Manage Locations',
  MANAGE_USERS: 'Manage Users',
  NUMBER_ACTION: 'Number Action',
} as const;

export const BASE_PERMISSION = {
  READ: 'read',
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
  VIEW: 'view_permission',
} as const;

export type PermissionAction = (typeof BASE_PERMISSION)[keyof typeof BASE_PERMISSION];

export const POLL_INTERVAL = {
  THIRTY_SECONDS: 30_000,
  FORTY_FIVE_SECONDS: 45_000,
} as const;
